import {
  TextField,
  Box,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  ListItemText,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { authedAxios } from '../utils'
import {
  OUTCOMES,
  TASK_TYPE_DROPDOWN_MAP,
  TASK_TYPE_ICON_MAP,
  TASK_TYPE_MODAL_DISPLAY_NAMES,
} from '../constants'
import { useStore } from '../store'
import { TASK_MODALS_ACTIONS } from '../store/tasks'
import useDropdowns from '../hooks/api/useDropdowns'

const TaskOutcome = ({
  taskType,
  onSaveProp,
  task,
  onClose,
  customer,
  contact,
  setOutcomeMode,
}) => {
  const [outcome, setOutcome] = useState(OUTCOMES[0])
  const [taskOutcome, setTaskOutcome] = useState('')
  const [note, setNote] = useState('')
  const [activities, setActivities] = useState([])

  const [activityTypes, setActivityTypes] = useState([])

  const next = () => {
    setOutcomeMode?.(false)
    onSaveProp(task)
  }

  const { dropdownsSummary, isLoading } = useDropdowns()

  useEffect(() => {
    authedAxios
      .get('/api/task/outcome-types')
      .then((res) => {
        setActivityTypes(res.data.activityTypes)
      })
      .catch((e) => {
        next()
      })
  }, [])

  const save = () => {
    return authedAxios.put(`/api/task/${task.id}/outcome`, {
      ...task,
      outcome,
      note,
      taskOutcome,
      activities,
    })
  }

  const onSave = () => {
    save().finally(() => {
      next()
    })
  }

  const { dispatch } = useStore()

  const saveAndNew = () => {
    save().finally(() => {
      next()
      dispatch({
        type: TASK_MODALS_ACTIONS.CREATE_TASK_MODAL,
        taskModal: {
          task,
          customer: {
            id: task.customerId,
            name: task.customerName,
            ...customer,
          },
          contact: { id: task.customerContactId, ...contact },
        },
      })
    })
  }

  if (isLoading) return null

  const taskTypeName = TASK_TYPE_MODAL_DISPLAY_NAMES[task?.taskTypeId]
  const TaskIcon = TASK_TYPE_ICON_MAP[task.taskTypeId]
  const dropdownKey = TASK_TYPE_DROPDOWN_MAP[task.taskTypeId]

  const taskOutcomes =
    dropdownsSummary.find((ds) => ds.key === dropdownKey)?.options || []

  return (
    <>
      <DialogContent>
        <Box>
          {taskTypeName && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mt: 0,
                mb: 2,
                gap: 1,
              }}
            >
              <Typography sx={{ fontWeight: 'bold' }}>
                {taskTypeName}
              </Typography>

              {TaskIcon && <TaskIcon color='primary' />}
            </Box>
          )}
          <Typography sx={{ mb: 1 }}>
            Record the outcome of the completed task
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: ' wrap', gap: 1 }}>
            <TextField
              sx={{ minWidth: '300px' }}
              label='Outcome'
              margin='dense'
              select
              value={outcome}
              onChange={(e) => setOutcome(e.target.value)}
            >
              {OUTCOMES.map((o) => (
                <MenuItem key={o} value={o}>
                  {o}
                </MenuItem>
              ))}
            </TextField>

            {taskOutcomes?.length > 0 && (
              <TextField
                sx={{ minWidth: '300px' }}
                label='Outcome of task'
                margin='dense'
                select
                value={taskOutcome}
                onChange={(e) => setTaskOutcome(e.target.value)}
              >
                {taskOutcomes.map((o) => (
                  <MenuItem key={o} value={o.id}>
                    {o.name}
                  </MenuItem>
                ))}
              </TextField>
            )}
          </Box>

          <TextField
            sx={{ minWidth: '300px' }}
            margin='dense'
            label={'Log Activities'}
            select
            SelectProps={{
              multiple: true,
              renderValue: (selected) =>
                selected
                  .map((s) => activityTypes.find((at) => at.id === s).name)
                  .join(', '),
            }}
            value={activities}
            onChange={(e) => setActivities(e.target.value)}
          >
            {activityTypes.map((at) => (
              <MenuItem key={at.id} value={at.id}>
                <ListItemText>{at.name}</ListItemText>
              </MenuItem>
            ))}
          </TextField>

          <TextField
            onChange={(e) => setNote(e.target.value)}
            value={note}
            margin='dense'
            label={'Outcome Note'}
            fullWidth
            multiline
            rows={4}
          ></TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => onClose()}>
          Cancel
        </Button>
        <Button variant={'contained'} onClick={onSave}>
          Save Outcome
        </Button>
        <Button variant={'contained'} onClick={saveAndNew}>
          Save Outcome and New Task
        </Button>
      </DialogActions>
    </>
  )
}

export const TaskOutcomeModal = ({ open, onSave, task, onClose }) => {
  return (
    <Dialog open={open}>
      <DialogTitle>
        {task.customerName && <Box>{task.customerName}</Box>}
      </DialogTitle>

      <TaskOutcome
        taskType={task.taskTypeId}
        onSaveProp={onSave}
        task={task}
        onClose={onClose}
      ></TaskOutcome>
    </Dialog>
  )
}

export default TaskOutcome
